import {
  CategoryStatusPayload,
  EnrollmentStatusPayload,
  InboundWebPayloadType,
  PaginationRequestCorrespondenceLogs,
  ScrollableTypes,
} from '../types/correspondenceLogs.types'
import { previewTemplatePayloadType } from '../types/manualCommunication.types'
import axiosInstance from '../utils/axiosInstance'
import { API_END_POINT } from '../utils/environment'

const fetchAllCorrespondenceLogsApi = async (
  payload: PaginationRequestCorrespondenceLogs
) => {
  return await axiosInstance.get(
    `${API_END_POINT.TEMPLATE}/v1/communication-logs?sort=${payload.sort}&size=${payload.size}`
  )
}

const filterAllCorrespondenceLogsApi = async (
  payload: PaginationRequestCorrespondenceLogs
) => {
  return await axiosInstance.post(
    `${API_END_POINT.TEMPLATE}/v2/communication-logs/advance?page=${
      payload.page - 1
    }&size=${payload.size}`,
    payload,
    {
      params: {
        sort: payload?.sort,
      },
    }
  )
}

const resendCorrespondenceLogsApi = async (communication_id: string) => {
  return await axiosInstance.post(
    `${API_END_POINT.TEMPLATE}/v2/communications/resend/${communication_id}`
  )
}

const fetchAllCorrespondenceTemplateApi = async (
  payload: previewTemplatePayloadType
) => {
  return await axiosInstance.get(
    `${API_END_POINT.TEMPLATE}/v1/communication-logs/view/${payload?.templateId}`
  )
}

const filterDataOnScroll = async ({ key, payload }: ScrollableTypes) => {
  return await axiosInstance.post(
    `${API_END_POINT.TEMPLATE}/v2/communication-logs/filter-data/${key}?page=${payload.page}&size=${payload.size}`,
    payload
  )
}
const getServiceByServiceName = async (serviceName: string) => {
  return await axiosInstance.get(`${API_END_POINT.CORE}services/${serviceName}`)
}

const getCaseCommunicationIdByApi = async (endpoint: string) => {
  try {
    const response = await axiosInstance.get(
      `${API_END_POINT.TEMPLATE}/v2/communication-logs/${endpoint}`
    )
    if (response?.status !== 200) {
      return []
    }
    return response?.data?.map((item: number) => ({
      label: item?.toString(),
      value: item?.toString(),
    }))
  } catch (error) {
    console.error(error)
    return []
  }
}

const correspondenceInboundWebData = async (payload: InboundWebPayloadType) => {
  return await axiosInstance.post(
    `${API_END_POINT.ENTITY_MANAGER_V3}entity-data/get/hcp_portal_entity_cases`,
    payload
  )
}

const mergedPdfUrl = async (id: number) => {
  return await axiosInstance.get(
    `${API_END_POINT.DELIVERY}/v1/communications/get-presigned-url/merge-docs/${id}`
  )
}

const mergedInboundWebPdfUrl = async (enrollmentId: number) => {
  return await axiosInstance.get(
    `${API_END_POINT.DELIVERY}/v1/communications/web/${enrollmentId}/get-presigned-url/bulk-print`
  )
}

const changeRecordStatusForEntity = async (
  payload: EnrollmentStatusPayload | CategoryStatusPayload,
  recordId: number
) => {
  return await axiosInstance.patch(
    `${API_END_POINT.ENTITY_MANAGER_V3}entity-data/entities?ids=${recordId}`,
    payload
  )
}

export {
  fetchAllCorrespondenceLogsApi,
  getCaseCommunicationIdByApi,
  filterAllCorrespondenceLogsApi,
  fetchAllCorrespondenceTemplateApi,
  filterDataOnScroll,
  resendCorrespondenceLogsApi,
  getServiceByServiceName,
  correspondenceInboundWebData,
  mergedPdfUrl,
  mergedInboundWebPdfUrl,
  changeRecordStatusForEntity,
}
